// extracted by mini-css-extract-plugin
export default {"loader":"TwoSquareSpinner_loader__BemOa","rotationBreak":"TwoSquareSpinner_rotationBreak__8YxXK"};